import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/app-config.service';
import { Store } from '@ngxs/store';
import { Alert } from '../types/Alert';
import { EndBusyMessage } from '../state/app.state.actions';
import { AlertService } from '@dor-mvtrip/shared-angular-components';

@Injectable({
	providedIn: 'root'
})
export class ErrorInterceptorService implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(catchError((e) => this.handleAuthError(e)));
	}

	private handleAuthError(error: HttpErrorResponse): Observable<any> {
		//Redirect to login if request was not authorized
		if (error.status === 401) {
			window.location.href = this.configService.getConfig().loginUrl;
		}

		//TODO: find out why we have to leave a timeout for the state to hear these events
		setTimeout(() => {
			//Clear any busy messages and post the error alert
			this.store.dispatch(new EndBusyMessage());
			this.alertsService.addAlert(
				'danger',
				`We are sorry, but the server returned an error response. ${this.configService.getConfig()
					.enableDebugLogger
					? error.message
					: ''}`
			);
		}, 1000);

		return throwError(error);
	}

	constructor(private store: Store, private configService: AppConfigService, private alertsService: AlertService) {}
}
